import { COUNTRIES, FINANCIAL_PRODUCT, GOVERNMENT_FINANCIAL_PRODUCTS, IdentificationType } from '@brighte/validation';
import { IDENTIFICATION } from '@utils';

export const getCountryCode = () => {
  return COUNTRIES.map(country => ({ label: country }));
};

// UI-only radio choices for how a passport's issuing country is captured (not persisted). The
// selection drives whether the country dropdown is shown, and Australian auto-fills the country.
export const PASSPORT_ISSUER = { AUSTRALIA: 'AU', OVERSEAS: 'OVERSEAS' } as const;
export type PassportIssuer = (typeof PASSPORT_ISSUER)[keyof typeof PASSPORT_ISSUER];

// The combobox stores the country name as its value, so the auto-fill must match the COUNTRIES entry.
export const AUSTRALIA_ISSUING_COUNTRY = 'Australia';

export const getExpiryDateFieldName = (identificationType: IdentificationType, name: string) => {
  switch (identificationType) {
    case IdentificationType.MEDICARE:
      return `${name}.identification.medicare.expiryDate`;
    case IdentificationType.DRIVING_LICENSE:
      return `${name}.identification.drivingLicense.expiryDate`;
    case IdentificationType.PASSPORT:
      return `${name}.identification.passport.expiryDate`;
    default:
      return null;
  }
};

export const getIdentificationOptions = (
  financialProductId: string,
): { label: string; value: IdentificationType }[] => {
  let identificationOptions = IDENTIFICATION.IDENTIFICATION_OPTIONS;

  // Medicare option is not available for Brighte Flex, ACT & TAS products
  if ([FINANCIAL_PRODUCT.FLEX, ...GOVERNMENT_FINANCIAL_PRODUCTS].includes(financialProductId)) {
    identificationOptions = identificationOptions.filter(option => option.value !== IdentificationType.MEDICARE);
  }

  // State issued photo ID option is only available for ACT & TAS products, excluding act-solar-for-apartments-loan
  if (!GOVERNMENT_FINANCIAL_PRODUCTS.includes(financialProductId) || financialProductId === FINANCIAL_PRODUCT.ACT_SFA) {
    identificationOptions = identificationOptions.filter(option => option.value !== IdentificationType.PHOTO_ID);
  }

  return identificationOptions;
};
